import { gql } from '@apollo/client';
import { ErrorFragment } from '../fragments';

export const FAVORITE_BASIC_EVENT = gql`
  mutation favoriteBasicEvent($input: FavoriteBasicEventInput!) {
    favoriteBasicEvent(input: $input) {
      message
      errors {
        ...ErrorFields
      }
    }
  }
  ${ErrorFragment}
`;

export const FAVORITE_FIELD = gql`
  mutation favoriteField($input: FavoriteFieldInput!) {
    favoriteField(input: $input) {
      message
      errors {
        ...ErrorFields
      }
    }
  }
  ${ErrorFragment}
`;

export const FAVORITE_VERSION_ENTITY = gql`
  mutation favoriteVersionEntity($input: FavoriteVersionEntityInput!) {
    favoriteVersionEntity(input: $input) {
      message
      errors {
        ...ErrorFields
      }
    }
  }
  ${ErrorFragment}
`;

export const FAVORITE_ANALYSIS = gql`
  mutation favoriteAnalysis($input: FavoriteAnalysisInput!) {
    favoriteAnalysis(input: $input) {
      message
      errors {
        ...ErrorFields
      }
    }
  }
  ${ErrorFragment}
`;
